import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { action, computed } from 'mobx';
import { Model } from 'core/model/Model';
import AssetTagValueMappingCollection from './AssetTagValueMappingCollection';
let AssetTagValueModel = (_class = class AssetTagValueModel extends Model {
  constructor(...args) {
    super(...args);
    this.mappingCollection = new AssetTagValueMappingCollection([], {
      valueModel: this
    });
  }
  /**
   * No uppercase bunching, just sort by all lower
   */
  getSortValue(field) {
    if (field === 'value') {
      return this.get('value')?.toLowerCase();
    }
    return super.getSortValue(field);
  }

  /**
   * Provides data for rendering a list of links that route to auto-populated filters in an asset type's own list view.
   */
  get usage() {
    return this.mappingCollection.usage;
  }

  /**
   * Provides a count of mappings to associate with a value in the value table.
   */
  get mappingCount() {
    const {
      size,
      unfilteredSize
    } = this.mappingCollection;
    if (size !== unfilteredSize) {
      return `${size} of ${unfilteredSize}`;
    }
    return size;
  }

  /**
   * Returns a set of asset type/id mappings that should be regarded as disabled
   * These are mappings that already have a value under the given key.
   */
  get disabledMappings() {
    const disabled = new Set();
    this.collection?.get().forEach(valueModel => {
      if (valueModel.id !== this.id) {
        valueModel.mappingCollection.get().forEach(mappingModel => {
          const {
            asset_type,
            asset_id
          } = mappingModel.get();
          disabled.add(`${asset_type}:${asset_id}`);
        });
      }
    });
    return disabled;
  }
  removeMapping(models) {
    const mappingModels = Array.isArray(models) ? models : [models];
    mappingModels.forEach(mappingModel => {
      if (!mappingModel.isNew) {
        // mark persisted models for server-side delete
        // @ts-expect-error removedIds is there on the value collection
        this.collection.removedIds.add(mappingModel.id);
      }
      this.mappingCollection.remove(mappingModel.id);
    });
  }

  /**
   * Provides a mapping delete bulk action
   */
  get bulkActions() {
    return [{
      name: 'delete',
      label: 'Delete',
      intent: 'danger',
      icon: 'trash',
      handler: action(() => {
        const {
          mappingCollection
        } = this;
        mappingCollection.selectedArray.forEach(model => this.removeMapping(model));
        mappingCollection.clearSelection();
        mappingCollection.resetAssetCollections();
      })
    }];
  }
  deserialize(data) {
    const {
      mappings = [],
      ...modelProperties
    } = data;
    this.mappingCollection.set(mappings);
    return super.deserialize(modelProperties);
  }
}, _applyDecoratedDescriptor(_class.prototype, "usage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "usage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mappingCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mappingCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disabledMappings", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disabledMappings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeMapping", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeMapping"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bulkActions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "bulkActions"), _class.prototype), _class);
export { AssetTagValueModel as default };